import type { Language } from '@dorixona/i18n'
import ruFlag from '../assets/flags/ru.svg'
import uzFlag from '../assets/flags/uz.svg'

const FLAGS: Record<Language, string> = { ru: ruFlag, uz: uzFlag }

/**
 * Флаг языка. Пропорции у флагов разные (3:2 и 2:1), поэтому картинка
 * заполняет рамку: все флаги в списке одного размера. Декоративен — язык
 * называет подпись рядом.
 */
export function Flag({ code, className }: { code: Language; className?: string }) {
  return (
    <img
      className={className ? `flag ${className}` : 'flag'}
      src={FLAGS[code]}
      alt=""
      aria-hidden="true"
    />
  )
}
